import script from "./SubastasPrivadas.vue?vue&type=script&setup=true&lang=js"
export * from "./SubastasPrivadas.vue?vue&type=script&setup=true&lang=js"

import "./SubastasPrivadas.vue?vue&type=style&index=0&id=7fe6b4e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fe6b4e6"]])

export default __exports__